import RowPlaceholder from './RowPlaceholder';

const SelectPlaceholder = () => (
  <div className="p-2">
    {Array.from({ length: 9 }, (index: number) => (
      <RowPlaceholder key={index} />
    ))}
  </div>
);

export default SelectPlaceholder;
